import React, {Component} from 'react';
import {
  Container,
  Row,
  Col
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';
import Button from '../../../shared/components/Button';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import DropdownButton from '../../../shared/components/DropdownButton';


import {alphabeticallySort, capitalizeFirstLetter, generateGUID, textContains} from '../../../shared/utils';
import moment from "moment-timezone";
import {DEFAULT_TIMEZONE} from "../../../config";
import {loadRewardPromos} from "../../../shared/redux/entities/actions";

class RewardPromoList extends Component {
  constructor(props){
    super(props);
    this.state = {
      isLoading:false
    }
  }

  componentDidMount(){
    this.setState({isLoading:true});
      Promise.all(this.props.loadRewardPromos(), this.props.loadPromoDefaults())
      .then(() => this.setState({isLoading:false}))
      .catch(() => this.setState({isLoading:false}));
  }

  render(){
    const { rewardPromos, deletePromo, updatePromo, createPromo } = this.props;
    if (this.state.isLoading) {
        return <div>Loading...</div>
    }
    const deleteMenu = (id) => ({
        text:'Move to trash',
        confirmationText:'This is permanent and can not be reverted.',
        confirmationAcceptText:'Confirm',
        confirmationRejectText:'Cancel',
        onClick:() => deletePromo(id)
    })
    const endMenu = (id) => ({
        text:'End Promo',
        confirmationText:'This is permanent and can not be reverted.',
        confirmationAcceptText:'Confirm',
        confirmationRejectText:'Cancel',
        onClick:() => updatePromo(id, {status: 'ENDED'})
    })
      const duplicateMenu = (item) => ({
          text:'Duplicate',
          onClick:() => {
              const {id, ...promo} = item
              let startDate = Math.max(...(rewardPromos.filter(i => i.domain === item.domain).map(i=>i.startDate))) + 86400000*4
              let endDate = Math.max(...(rewardPromos.filter(i => i.domain === item.domain).map(i=>i.endDate))) + 86400000*4
              createPromo({...promo, status: 'DRAFT', name: `Copy of ${promo.name}`, startDate: startDate, endDate: endDate})
                  .then(() => loadRewardPromos())
          }
      })
    return (
        <div>
          <Row>
            <Col xs='12'>
              <SearchableDataTable
                  items={rewardPromos}
                  searchPromptText='Search by name'
                  emptyText='There are no reward promos'
                  columns={[
                    {
                      display: 'Name',
                      name:'name',
                      width:20,
                      sortFunc:(a,b) => alphabeticallySort(a.name,b.name),
                      filterFunc:(a,searchParam) => textContains(a.name,searchParam),
                      renderCell:(item) => (
                          <div>
                              <Link to={`${this.props.match.url}/${item.id}`}>{item.name}</Link>
                          </div>
                      )
                    },
                    {
                      name:'status',
                      width:10,
                      renderCell:(item) => (
                          <div>
                            <span>{item.status}</span>
                          </div>
                      )
                    },
                      {
                          name:'domain',
                          width:10,
                          renderCell:(item) => (
                              <div>
                                  <span>{capitalizeFirstLetter(item.domain)}</span>
                              </div>
                          )
                      },
                    {
                      name:'startDate',
                      display:'Start Date',
                      width:15,
                      sortFunc:(a,b) => a.startDate - b.startDate,
                      renderCell:(item) => <span>{moment(item.startDate).tz(DEFAULT_TIMEZONE).format('MMM D, YYYY')}</span>
                    },
                    {
                      name:'endDate',
                      display:'Expiration Date',
                      width:15,
                      sortFunc:(a,b) => a.endDate - b.endDate,
                      renderCell:(item) => <span>{moment(item.endDate).tz(DEFAULT_TIMEZONE).format('MMM D, YYYY')}</span>
                    }
                    ,{
                      width:20,
                      renderCell:(item) => (
                          <div className='pull-right'>
                              <Button
                                  size='sm'
                                  linkHref={`${this.props.match.url}/${item.id}`}
                                  textColor='#666666'
                                  borderColor='#cccccc'
                                  backgroundColor='#fff'
                              >
                                  Edit
                              </Button>
                              &nbsp;&nbsp;
                              <DropdownButton
                                  options={(item.status === 'ACTIVE' || item.status === 'READY') ? [endMenu(item.id), deleteMenu(item.id), duplicateMenu(item)] : [deleteMenu(item.id), duplicateMenu(item)]}
                              />
                          </div>
                      )
                    }
                  ]}
              />
              <br />
              <br />
              <br />
            </Col>
          </Row>
        </div>
    )
  }
}

export default RewardPromoList;



// WEBPACK FOOTER //
// ./src/routes/RewardPromoList/components/RewardPromoList.js